export default __webpack_public_path__ + "media/zurb/img/events/wired/life-services-timeline1-a8f2b42df730dac87f01397e08b76057.png";